import React from 'react';

const DoubleHappiness = ({ size = 100, color = '#de2910' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className="inline-block"
    >
      <text
        x="50"
        y="70"
        fontSize="60"
        fill={color}
        textAnchor="middle"
        fontFamily="serif"
        fontWeight="bold"
      >
        囍
      </text>
    </svg>
  );
};

export default DoubleHappiness;


